import Heading2 from "./Heading2";
import { getBrokerInformation } from "../store/broker";
import { useSelector } from "react-redux";

const ActionCentreText = (props) => {
  const brokerage = useSelector(getBrokerInformation);
  const languagepreference = brokerage.information.languagepreference;

  const translations = {
    en: {
      actionCentre: "Action Centre",
      infoCentre: "Info Centre"
    },
    fr: {
      actionCentre: "Centre d'Action",
      infoCentre: "Centre d'Info"
    },
  };
  let text = props?.id == "info" ?  translations[languagepreference].infoCentre : translations[languagepreference].actionCentre
  return (
    <Heading2 text={text}></Heading2>
  );
};


export default ActionCentreText;
